import React, { Component } from 'react';
import './styles.css';

export class PageNotFound extends Component {
  render() {
    return (
      <div className="not-found-container">
        <div className="not-found-content">
          <h1 className="error-code">404</h1>
          <h2 className="error-title">Page Not Found</h2>
          <p className="error-message">
            This page is no longer available.
          </p>
        </div>
      </div>
    );
  }
}

export default PageNotFound;
